module.exports = __webpack_public_path__ + "img/cat.8bf6aebc.svg";